<template>
  <v-btn :ripple="false" flat v-on:click.native="onLangPress">{{lang}}</v-btn>
</template>

<script>
import Vue from "vue";
import i18n, { changeLocale, SUPPORTED_LANGUAGES } from "../i18n/i18n";
import { i18nHelper } from "../services/i18nHelper";

export default {
  name: "LanguageSwitch",
  data: () => {
    return {
      lang: null
    };
  },
  methods: {
    onLangPress: function() {
      const translatedPage = i18nHelper.translatedPage;
      let routeName = translatedPage.routeName;
      const params = {
        lang: translatedPage.langParam
      };
      if (routeName === "project" || routeName === "projekt") {
        params.projectSlug = translatedPage.pageSlug;
      } else if (routeName === "pageWrap") {
        params.pageSlug = translatedPage.pageSlug;
      }

      this.$router.push({
        name: routeName,
        params
      });

      this.$router.go();
    }
  },
  created() {
    const currentRoute = this.$router.currentRoute;
    if (currentRoute && currentRoute.params && currentRoute.params.lang) {
      const currentLang = currentRoute.params.lang;
      if (currentLang === SUPPORTED_LANGUAGES[0]) {
        this.lang = SUPPORTED_LANGUAGES[1];
      } else {
        this.lang = SUPPORTED_LANGUAGES[0];
      }
    }
  }
};
</script>